<div class="card ">
  <div class="card-header card-header-rose card-header-icon">
    <div class="card-icon">
      <i class="material-icons">delete_forever</i>
    </div>
    <h4 class="card-title">{{ title }}</h4>
  </div>
  <div class="card-body ">
    {{ message }}
  </div>
  <div class="card-footer ">
    <button _ngcontent-cfq-c3="" (click)="dialogRef.close(false)" class="btn btn-fill btn-rose">Annuler</button>
    <button mat-raised-button (click)="dialogRef.close(true)" type="submit" class="btn btn-fill btn-rose">Valider</button>
  </div>
</div>
